module.exports = __webpack_public_path__ + "assets/img/juqu_content_img.bb995d95.png";